import styled from "styled-components";

export const BtnStyle = styled.button`
  width: ${({ small }) => (small ? small : "100%")};
  background-color: ${({ bgColor }) => (bgColor ? bgColor : "#fff")};
  /* border: ${({ color }) => (color ? `1px solid ${color}` : " none")}; */
  border: ${({ border }) => (border ? `1px solid ${border}` : "none")};
  font-family: "IRANSans";
  font-size: ${({ size }) => size};
  outline: none;
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 5px;
  color: ${({ color }) => color};
  margin-top: ${({ spaceTop }) => spaceTop};
  margin-left: ${({ spaceLeft }) => spaceLeft};
  ${({ style }) => style}

  a {
    text-decoration: none;
    color: #fff;
  }

  &:hover {
    ${({ hover }) => hover}
  }
  @media (max-width: 768px) {
    padding: 4px;
    a {
      font-size: 14px;
    }
  }
`;
